export default __webpack_public_path__ + "static/media/showcase-parenting-1.559ed7cc.jpg";